import { Image, Text, VStack, Wrap } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getSponsorData } from "../../../store/sponsor/selectors";

export default function FooterOrganizzatori() {
  const sponsors = useSelector(getSponsorData);

  return (
    <Wrap justify="center" spacing="50px" p="50px">
      {sponsors?.some((sponsor) => sponsor.isOrganizer && sponsor.show) && (
        <VStack>
          <Text textAlign="center">Organizzato da</Text>
          <Wrap justify="center">
            {sponsors?.map((sponsor) =>
              sponsor.isOrganizer && sponsor.show ? (
                <Image src={sponsor.logoUrl} maxHeight="100px" mx={3} />
              ) : null,
            )}
          </Wrap>
        </VStack>
      )}
      {sponsors?.some((sponsor) => sponsor.isCollaborator && sponsor.show) && (
        <VStack>
          <Text textAlign="center">In collaborazione con</Text>
          <Wrap justify="center">
            {sponsors?.map((sponsor) =>
              sponsor.isCollaborator && sponsor.show ? (
                <Image src={sponsor.logoUrl} maxHeight="100px" mx={3} />
              ) : null,
            )}
          </Wrap>
        </VStack>
      )}
      {sponsors?.some((sponsor) => sponsor.isPatrocinio && sponsor.show) && (
        <VStack>
          <Text textAlign="center">Con il patrocinio</Text>
          <Wrap justify="center">
            {sponsors?.map((sponsor) =>
              sponsor.isPatrocinio && sponsor.show ? (
                <Image src={sponsor.logoUrl} maxHeight="100px" mx={3} />
              ) : null,
            )}
          </Wrap>
        </VStack>
      )}
    </Wrap>
  );
}
